/**
 * Sentinel value used as end_date when no end date is specified.
 * Represents "indefinite" / "no end date" in prestation planning rows.
 */
export const SENTINEL_END_DATE = '2050-01-01'
